/* =====================================================================
   OxiTab Blog Post — TOC Builder + Article FAQ Accordion
   FAQ schema is generated in Liquid, not JavaScript.
   ===================================================================== */

(function () {
  'use strict';

  function cleanText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initTableOfContents() {
    var wrapper = document.querySelector('.oxitab-blog-wrapper');

    if (!wrapper) return;

    var body = wrapper.querySelector('.oxitab-blog-body');
    var list = wrapper.querySelector('.oxitab-toc-list');

    if (!body || !list) return;

    list.innerHTML = '';

    /*
      Build TOC from article H2s only.

      The FAQ heading is excluded because the FAQ lives inside the article,
      but we do not want it duplicated in the Table of Contents.
    */
    var headings = body.querySelectorAll('h2');

    if (!headings.length) return;

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var slug = cleanText(heading.textContent)
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 60);

        heading.id = slug ? slug + '-' + index : 'section-' + index;
      }

      var li = document.createElement('li');
      var link = document.createElement('a');

      link.href = '#' + heading.id;
      link.textContent = cleanText(heading.textContent);
      link.dataset.target = heading.id;

      li.appendChild(link);
      list.appendChild(li);
    });

    if ('IntersectionObserver' in window) {
      var links = list.querySelectorAll('a');
      var byId = {};

      links.forEach(function (link) {
        byId[link.dataset.target] = link;
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var activeLink = byId[entry.target.id];

            if (!activeLink) return;

            if (entry.isIntersecting) {
              links.forEach(function (link) {
                link.classList.remove('is-active');
              });

              activeLink.classList.add('is-active');
            }
          });
        },
        {
          rootMargin: '-30% 0px -60% 0px',
          threshold: 0
        }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function getFaqItems() {
    return document.querySelectorAll(
      '.oxitab-blog-wrapper .oxitab-article-faq__item'
    );
  }

  function initFaqAccordion() {
    var faqItems = Array.prototype.slice.call(getFaqItems());

    if (!faqItems.length) return;

    faqItems.forEach(function (details, index) {
      if (details.dataset.oxitabFaqEnhanced === 'true') return;

      details.dataset.oxitabFaqEnhanced = 'true';

      var summary = details.querySelector('.oxitab-article-faq__question');
      var answer = details.querySelector('.oxitab-article-faq__answer');

      if (summary && answer) {
        var summaryId = summary.id || 'oxitab-faq-summary-' + index;
        var answerId = answer.id || 'oxitab-faq-answer-' + index;

        summary.id = summaryId;
        answer.id = answerId;

        summary.setAttribute('aria-controls', answerId);
        answer.setAttribute('role', 'region');
        answer.setAttribute('aria-labelledby', summaryId);
      }

      details.addEventListener('toggle', function () {
        if (!details.open) return;

        faqItems.forEach(function (otherDetails) {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });
      });
    });
  }

  function initArticleFaq() {
    initFaqAccordion();
  }

  function initOxiTabBlog() {
    initTableOfContents();
    initArticleFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOxiTabBlog);
  } else {
    initOxiTabBlog();
  }

  window.addEventListener('load', initOxiTabBlog);

  document.addEventListener('shopify:section:load', function () {
    initOxiTabBlog();
  });
})();